export default __webpack_public_path__ + "static/media/8.2.ca8b7ed8.jpg";